export default __webpack_public_path__ + "static/media/WINE10.5ab5b4b9.jpg";